const DELTAP_MAPPING = {
  LMH: {
    rear: 0.5,
    front: 0.6,
  },
  LMP1: {
    rear: 0.7,
    front: 0.7,
  },
  LMP2: {
    rear: 0.6,
    front: 0.6,
  },
  GT500: {
    rear: 0.6,
    front: 0.6,
  },
  GT300: {
    rear: 0.6,
    front: 0.6,
  },
  GTE: {
    rear: 0.6,
    front: 0.6,
  },
  "GTD_GT-perfo": {
    rear: 0.6,
    front: 0.6,
  },
  CC: {
    rear: 0.6,
    front: 0.6,
  },
  "Green GT": {
    rear: 0.6,
    front: 0.6,
  },
  "FR 3.5": {
    rear: 0.4,
    front: 0.4,
  },
  "FIA GT": {
    rear: 0.4,
    front: 0.4,
  },
  F1: {
    rear: 0.3,
    front: 0.3,
  },
  "Porsche Cup": {
    rear: 0.8,
    front: 0.8,
  },
  "Porsche E-GT": {
    rear: 0.8,
    front: 0.8,
  },
  FormulaE: {
    rear: 0.3,
    front: 0.3,
  },
  NLS: {
    rear: 0.6,
    front: 0.6,
  },
  TCR: {
    rear: 0.6,
    front: 0.6,
  },
  Track_Days: {
    rear: 0.6,
    front: 0.6,
  },
};

const DELTAP_EVOL_MAPPING = {
  0.3: {
    3: "0.16 0.10 .0.4",
    4: "0.12 0.09 0.06 0.03",
    5: "0.11 0.08 0.06 0.03 0.02",
    6: "0.09 0.07 0.06 0.04 0.02 0.02",
    10: "0.05 0.04 0.04 0.03 0.03 0.03 0.03 0.02 0.02 0.01",
  },
  0.4: {
    3: "0.22 0.12 0.06",
    4: "0.17 0.12 0.08 0.03",
    5: "0.15 0.11 0.07 0.04 0.03",
    6: "0.12 0.10 0.08 0.05 0.03 0.02",
    7: "0.11 0.09 0.07 0.05 0.03 0.03 0.02",
    8: "0.08 0.08 0.07 0.06 0.04 0.03 0.02 0.02",
  },
  0.5: {
    3: "0.25 0.17 0.08",
    4: "0.21 0.15 0.10 0.04",
    5: "0.18 0.13 0.09 0.07 0.03",
    6: "0.15 0.12 0.10 0.07 0.04 0.02",
    7: "0.15 0.11 0.08 0.06 0.04 0.04 0.02",
    8: "0.11 0.10 0.09 0.06 0.05 0.04 0.03 0.02",
    9: "0.11 0.08 0.07 0.06 0.05 0.04 0.04 0.03 0.02",
    10: "0.10 0.08 0.07 0.06 0.05 0.04 0.03 0.03 0.02 0.02",
  },
  0.6: {
    2: "0.40 0.20",
    3: "0.29 0.21 0.10",
    4: "0.25 0.18 0.12 0.05",
    5: "0.21 0.17 0.11 0.07 0.04",
    6: "0.19 0.15 0.10 0.08 0.05 0.03",
    7: "0.18 0.13 0.09 0.07 0.06 0.05 0.02",
    8: "0.15 0.12 0.10 0.07 0.06 0.05 0.03 0.02",
    9: "0.11 0.10 0.09 0.08 0.07 0.06 0.04 0.03 0.02",
    10: "0.10 0.09 0.08 0.07 0.06 0.06 0.05 0.04 0.03 0.02",
    11: "0.10 0.08 0.08 0.07 0.06 0.05 0.05 0.04 0.03 0.02 0.02",
  },
  0.7: {
    3: "0.33 0.25 0.12",
    4: "0.29 0.21 0.14 0.06",
    5: "0.24 0.20 0.14 0.08 0.04",
    6: "0.21 0.17 0.14 0.10 0.05 0.03",
    7: "0.20 0.15 0.11 0.09 0.07 0.05 0.03",
    8: "0.19 0.14 0.10 0.09 0.06 0.05 0.04 0.03",
    9: "0.13 0.12 0.10 0.09 0.08 0.07 0.05 0.04 0.02",
    10: "0.12 0.11 0.09 0.09 0.07 0.07 0.05 0.05 0.03 0.02",
    11: "0.11 0.10 0.09 0.08 0.07 0.07 0.05 0.05 0.03 0.03 0.02",
  },
  0.8: {
    3: "0.35 0.30 0.15",
    4: "0.32 0.26 0.15 0.07",
    5: "0.27 0.22 0.16 0.09 0.06",
    6: "0.24 0.20 0.15 0.11 0.07 0.03",
    7: "0.21 0.17 0.14 0.11 0.08 0.06 0.03",
    8: "0.20 0.16 0.12 0.11 0.08 0.06 0.04 0.03",
    9: "0.14 0.13 0.12 0.11 0.09 0.07 0.06 0.05 0.03",
    10: "0.13 0.12 0.11 0.10 0.08 0.08 0.06 0.05 0.04 0.03",
    11: "0.12 0.11 0.10 0.09 0.09 0.07 0.06 0.06 0.04 0.03 0.03",
  },
};

export const getLapCount = (dist) => (dist ? Math.ceil(30 / dist) : undefined);

export const getDeltaP = (cat, pos) => {
  const posMap = { F: "front", R: "rear" };
  const position = posMap[pos?.[0]];

  return cat && pos ? (DELTAP_MAPPING?.[cat]?.[position] ?? 0) : 0;
};

export const getSuggestedDeltaP = (pressureEvol) => {
  if (!pressureEvol) return "";
  return (
    Object.keys(DELTAP_EVOL_MAPPING).find((deltaP) =>
      Object.values(DELTAP_EVOL_MAPPING[deltaP]).includes(pressureEvol),
    ) ?? ""
  );
};

export const getPressureEvol = (deltaP, lapCount) => {
  return deltaP && lapCount ? (DELTAP_EVOL_MAPPING?.[deltaP]?.[lapCount] ?? "") : "";
};
